import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    tokens: {
        "--theme-tracking": "-0.015em",
    },
};
